import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	developmentEnvironmentLozenge: {
		id: 'forge-ui-extension-title.environment-lozenge.development-environment-lozenge',
		defaultMessage: 'DEV',
		description: 'Navigation item lozenge label for forge apps on development environment',
	},
	stagingEnvironmentLozenge: {
		id: 'forge-ui-extension-title.environment-lozenge.staging-environment-lozenge',
		defaultMessage: 'STG',
		description: 'Navigation item lozenge label for forge apps on staging environment',
	},
});
